angular.module('SpidApp')

.directive('skCube',
		[
		 function() {
			
			return {
				priorty:1 ,
				restrict: 'E',
				template: '<div ng-if="display" class="sk-cube-grid">'+
				'<div class="sk-cube sk-cube1"></div>'+
				'<div class="sk-cube sk-cube2"></div>'+
				'<div class="sk-cube sk-cube3"></div>'+
				'<div class="sk-cube sk-cube4"></div>'+
				'<div class="sk-cube sk-cube5"></div>'+
				'<div class="sk-cube sk-cube6"></div>'+
				'<div class="sk-cube sk-cube7"></div>'+
				'<div class="sk-cube sk-cube8"></div>'+
				'<div class="sk-cube sk-cube9"></div>'+
				'</div>',
				link: function(scope) {
					scope.display = false;
					scope.$on('loading',function(event,data){
						scope.display = data[0];
					})
				}
			}
		}
]);

